import type { onboarding as en } from "../en/onboarding";
import type { Messages } from "../types";

export const onboarding: Messages<typeof en> = {
  stepOf: "الخطوة {{n}} من {{total}}",
  back: "رجوع",
  next: "متابعة",
  skip: "تخطَّ الآن",
  skipSetup: "تخطي الإعداد",
  finish: "إلى الصفحة الرئيسية",
  steps: {
    connect: "اربط إنستغرام",
    ai: "كيف يساعدك الذكاء الاصطناعي",
    rules: "قواعد البداية",
    ready: "جاهز",
  },
  welcome: {
    title: "أهلاً بك في منصة ملفك يا {{name}}",
    body: "لنجهّز {{org}} خلال دقيقتين تقريباً. تجمع منصة ملفك تعليقات إنستغرام ورسائله في صندوق واحد، وتقترح ردوداً بأسلوبك، وتتولى العمل المتكرر بالقواعد.",
  },
  connect: {
    title: "اربط إنستغرام",
    hint: "تستخدم منصة ملفك تسجيل الدخول الرسمي من ميتا. لا نرى كلمة مرورك أبداً.",
    instagram: "إنستغرام",
    instagramHint: "حسابات الأعمال وصنّاع المحتوى: التعليقات والرسائل والنشر والإحصاءات.",
    connectInstagram: "ربط إنستغرام",
    connecting: "جارٍ الربط…",
    connected: "تم الربط",
    connectedAs: "مربوط باسم ‎@{{user}}",
    followers: "{{n}} متابع",
    live: "التحديثات المباشرة",
    liveOn: "التحديثات المباشرة: مفعّلة",
    liveOff: "التحديثات المباشرة: قيد التشغيل",
    redirecting: "جارٍ التحويل إلى إنستغرام…",
    failed: "تعذّر ربط إنستغرام. حاول مرة أخرى.",
    soon: "فيسبوك وماسنجر وواتساب وثريدز وتيك توك قريباً.",
    needOne: "اربط حساباً للمتابعة، أو تخطَّ الآن.",
    askAdmin: "اطلب من مالك أو مسؤول في {{org}} ربط إنستغرام. يمكنك المتابعة في الأثناء.",
    rulesTitle: "ما يسمح به إنستغرام",
  },
  expect: {
    items: {
      inbox: "تصل التعليقات والرسائل الجديدة مباشرة إلى صندوق واحد، موسومة حسب موضوعها ومشاعر أصحابها.",
      window: "يمكنك الرد على الرسالة بحرية خلال 24 ساعة من آخر رسالة للعميل. بعدها تُقفل المحادثة حتى يكتب من جديد.",
      privateReply: "يمكنك إرسال رد خاص واحد (رسالة) لكل تعليق، خلال 7 أيام منه.",
      publishing: "يمكنك نشر حتى 100 منشور لكل حساب كل 24 ساعة.",
      views: "الوصول والمشاهدات تأتي مباشرة من إنستغرام.",
      safety: "لا يُرسَل أي شيء إلا بقاعدة فعّلتها، أو بنقرة منك.",
    },
  },
  ai: {
    title: "كيف يساعدك الذكاء الاصطناعي",
    hint: "يقرأ الذكاء الاصطناعي كل تعليق ورسالة جديدة، ويضع لها وسماً، ويقترح رداً بأسلوب علامتك. أنت من يقرر ما يُرسل.",
    toggle: "الذكاء الاصطناعي لـ ‎@{{user}}",
    suggest: "اقتراح الردود",
    suggestHint: "تنتظرك الاقتراحات في صندوق الوارد لترسلها.",
    off: "إيقاف",
    offHint: "بلا ذكاء اصطناعي لهذا الحساب. يمكنك تفعيله لاحقاً من الإعدادات.",
    noAccount: "اربط حساباً أولاً لتفعيل الذكاء الاصطناعي.",
    safe: "لا يُرسل شيء دونك. يمكنك تغيير ذلك في أي وقت من الإعدادات ← الذكاء الاصطناعي والمعرفة.",
    modes: {
      auto: "تلقائي",
      approve: "اسألني أولاً",
      suggest: "اقتراح فقط",
    },
  },
  rules: {
    title: "ابدأ ببعض القواعد المجرّبة",
    hint: "تبدأ بوضع «اقتراح فقط»: يجهّز الذكاء الاصطناعي الرد وترسله أنت. يمكنك تحويلها إلى التلقائي لاحقاً.",
    selected_zero: "لم تختر شيئاً",
    selected_one: "قاعدة واحدة مختارة",
    selected_two: "قاعدتان مختارتان",
    selected_few: "{{count}} قواعد مختارة",
    selected_many: "{{count}} قاعدة مختارة",
    selected_other: "{{count}} قاعدة مختارة",
    none: "لا توجد قواعد جاهزة بعد.",
    noAccount: "اربط حساباً لإنشاء قواعد البداية. يمكنك إضافتها لاحقاً من القواعد.",
    create_zero: "متابعة",
    create_one: "إنشاء قاعدة واحدة",
    create_two: "إنشاء قاعدتين",
    create_few: "إنشاء {{count}} قواعد",
    create_many: "إنشاء {{count}} قاعدة",
    create_other: "إنشاء {{count}} قاعدة",
    creating: "جارٍ إنشاء قواعدك…",
    created_zero: "لم تُنشأ أي قاعدة",
    created_one: "تم إنشاء قاعدة واحدة بوضع «اقتراح فقط»",
    created_two: "تم إنشاء قاعدتين بوضع «اقتراح فقط»",
    created_few: "تم إنشاء {{count}} قواعد بوضع «اقتراح فقط»",
    created_many: "تم إنشاء {{count}} قاعدة بوضع «اقتراح فقط»",
    created_other: "تم إنشاء {{count}} قاعدة بوضع «اقتراح فقط»",
  },
  ready: {
    title: "كل شيء جاهز",
    body: "منصة ملفك تتابع حسابك الآن. ستظهر التعليقات والرسائل الجديدة في صندوق الوارد فور وصولها، وترشدك الصفحة الرئيسية إلى أول ردودك.",
    next: "الخطوات التالية",
    tips: {
      inbox: "ردّ على أول تعليق باستخدام الرد المقترح",
      rule: "فعّل قاعدة عندما تثق بها",
      post: "خطّط لمنشورك القادم في أفضل وقت",
    },
    invite: "ادعُ فريقك",
    inviteHint: "أضف زملاءك من الإعدادات ← الفريق والأدوار.",
  },
};
